import styled from 'styled-components'

export const Banner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  box-sizing: border-box;
  background:
    linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.coldCharcoal300} 0%,
      ${({ theme }) => theme.colors.coldCharcoal500} 35%,
      ${({ theme }) => theme.colors.coldCharcoal500} 65%,
      ${({ theme }) => theme.colors.coldCharcoal300} 100%
    ),
    ${({ theme }) => theme.colors.coldCharcoal400};
`

export const BannerText = styled.p`
  margin: 0;
  font-size: 10px;
  line-height: 1.3;
  color: #fff;
  text-align: center;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints?.tablet}px) {
    white-space: nowrap;
    font-size: 12px;
  }
`

export const BannerHighlight = styled.span`
  font-weight: 700;
  text-transform: uppercase;
`
